import { Carousel, Col, Row } from 'react-bootstrap';
import McoCustomerInfo from './McoCustomerInfo';
import classes from './McoBanner.module.scss';
import McoPieChart from './McoPieChart';

const Banner = (props) => {
  return (
    <Carousel>
      <Carousel.Item>
        <section
          className={`${classes['banner-wrapper']} animate__animated animate__fadeIn animate__slower`}>
          <Row>
            <Col
              md={9}
              xxl={9}
              className='ps-0'>
              <McoCustomerInfo />
            </Col>
            <Col
              md={3}
              xxl={3}
              className='pe-0'>
              <McoPieChart />
            </Col>
          </Row>
        </section>
      </Carousel.Item>
    </Carousel>
  );
};

export default Banner;
